/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
/* eslint-disable import/extensions */
import React, { useEffect, useRef, useState } from 'react';

import ScanImg from '../../assets/images/florai/scan.png';
import InfoImg from '../../assets/images/florai/info.png';
import LeafcardImg from '../../assets/images/florai/leafcard.png';
import FloraiSectionBackdrop from './FloraiSectionBackdrop';

const steps = [
  {
    badge: 'STEP 01 · SCAN',
    badgeClass: 'text-[#24361B] bg-[#98CC6B]',
    title: <>Point your camera</>,
    body: (
      <>
        Frame the plant or mushroom in the viewfinder —
        {' '}
        <b>Identify</b>
        {' '}
        for species,
        {' '}
        <b>360 Identify</b>
        {' '}
        for tricky angles. No account needed, in Vietnamese or English.
      </>
    ),
  },
  {
    badge: 'STEP 02 · SAFETY VERDICT',
    badgeClass: 'text-white bg-[#ED7A3B]',
    title: (
      <>
        The warning comes
        {' '}
        <em className="font-instrument-serif !font-normal">first</em>
      </>
    ),
    body: (
      <>
        When a species has a dangerous look-alike, the verdict leads the result — before the name,
        before the photos. FlorAI never marks a risky species as “safe to eat”, and first aid is one
        tap away.
      </>
    ),
  },
  {
    badge: 'STEP 03 · PLANT INFO',
    badgeClass: 'text-[#24361B] bg-[#98CC6B]',
    title: <>The full picture on one card</>,
    body: (
      <>
        Toxicity for humans and pets, weed potential, distribution, plant type, lifespan — plus a
        Care tab with a water calculator, sunlight and soil guides. Save it to My Garden with one
        tap.
      </>
    ),
  },
  {
    badge: 'STEP 04 · PLANT EXPERT',
    badgeClass: 'text-[#24361B] bg-[#98CC6B]',
    title: (
      <>
        Ask the
        {' '}
        <em className="font-instrument-serif !font-normal">AI botanist</em>
      </>
    ),
    body: (
      <>
        Describe symptoms in your own words — yellow leaves, brown spots, wilting — and get advice
        grounded in your plant&apos;s species and snap history.
      </>
    ),
  },
];

// Phone screens for each step: scan viewfinder, safety verdict, plant info, expert chat
function PhoneScreens({ active }) {
  const screenStyle = (i) => ({
    opacity: active === i ? 1 : 0,
    zIndex: active === i ? 2 : 1,
    pointerEvents: 'none',
    transform: active === i ? 'scale(1)' : 'scale(1.03)',
    transition: 'opacity .55s ease, transform .55s ease',
  });

  return (
    <>
      <div className="absolute inset-0" style={screenStyle(0)}>
        <img src={ScanImg} alt="Camera viewfinder scanning leaves" className="absolute inset-0 w-full h-full object-cover" />
        <span className="florai-sweep absolute left-6 right-6 h-0.5 rounded" />
        <span className="absolute left-1/2 -translate-x-1/2 bottom-[118px] bg-[rgba(10,20,12,.78)] text-[#D8E2D3] text-[.72rem] font-semibold px-3.5 py-1.5 rounded-full whitespace-nowrap">
          Identifying…
          {' '}
          <span className="florai-pulse-dot">●</span>
        </span>
      </div>

      <div className="absolute inset-0 bg-[#F2F5EF] flex flex-col" style={screenStyle(1)}>
        <div className="relative h-[30%] flex-none">
          <img src={ScanImg} alt="Scanned mushroom" className="w-full h-full object-cover object-[center_30%]" />
          <span className="absolute top-3.5 left-3.5 w-7 h-7 rounded-full bg-white/90 grid place-items-center font-bold text-[#24361B]">‹</span>
        </div>
        <div className="flex-1 bg-[#F2F5EF] rounded-t-[20px] -mt-4 relative p-3.5 flex flex-col gap-2.5">
          <div className="bg-[#FBEADF] border border-[#F0C7AB] rounded-[14px] px-3 py-2.5 flex gap-2.5 items-start">
            <span className="flex-none w-[30px] h-[30px] rounded-[9px] bg-[#ED7A3B] text-white grid place-items-center font-extrabold">!</span>
            <div>
              <b className="text-[#C25517] text-[.88rem] block leading-snug">Toxic look-alike detected</b>
              <span className="text-[.74rem] text-[#9A5B33]">Do not eat. Verdict shown before identification.</span>
            </div>
          </div>
          <div className="bg-white border border-[#E1E8DC] rounded-[14px] px-3 py-3">
            <b className="text-[.9rem] block">Amanita sp. — Death cap group</b>
            <span className="text-[.72rem] text-[#5C6B53] italic">92% match · resembles edible paddy-straw mushroom</span>
            <div className="mt-2 flex flex-wrap gap-1.5">
              <span className="text-[.64rem] font-bold px-2.5 py-0.5 rounded-full bg-[#ED7A3B] text-white">Deadly — do not eat</span>
              <span className="text-[.64rem] font-bold px-2.5 py-0.5 rounded-full bg-[#FBEADF] text-[#C25517]">Common look-alike</span>
            </div>
          </div>
          <div className="bg-white border border-[#E1E8DC] rounded-[14px] px-3 py-2.5 text-[.74rem] text-[#5C6B53]">
            Symptoms can appear
            {' '}
            <b>6–24 hours</b>
            {' '}
            after eating. If already consumed, keep a sample and seek care now.
          </div>
          <div className="mt-auto flex flex-col gap-2">
            <span className="bg-[#ED7A3B] text-white font-bold text-[.84rem] text-center py-3 rounded-full">＋ First aid &amp; poison control</span>
          </div>
        </div>
      </div>

      <div className="absolute inset-0" style={screenStyle(2)}>
        <img src={InfoImg} alt="Plant Info screen with toxicity details" loading="lazy" className="absolute inset-0 w-full h-full object-cover object-top" />
      </div>

      <div className="absolute inset-0 bg-[#F2F5EF] flex flex-col" style={screenStyle(3)}>
        <div className="flex-none bg-white border-b border-[#E1E8DC] px-3.5 pt-4 pb-3 flex items-center gap-2.5">
          <span className="w-9 h-9 rounded-full bg-[#98CC6B] grid place-items-center flex-none">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M12 21c6-4 8-9 8-13-5 0-9 2-11 6M12 21C6 17 4 12 4 8c3 0 6 1 8 3m0 10V11" stroke="#24361B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <div>
            <b className="text-[.9rem] block leading-tight">Plant Expert</b>
            <span className="text-[.7rem] text-[#5B8F3C]">● AI botanist · online</span>
          </div>
        </div>
        <div className="flex-1 p-3.5 flex flex-col gap-2.5 overflow-hidden">
          <div className="self-end max-w-[82%] flex flex-col gap-1.5 items-end">
            <img src={LeafcardImg} alt="User snap of hibiscus leaves" className="w-[120px] h-[92px] object-cover rounded-xl border border-[#E1E8DC]" />
            <span className="bg-[#24361B] text-[#EEF2EC] text-[.76rem] px-3 py-2 rounded-[14px] rounded-br-[4px] leading-normal">
              My hibiscus has brown spots on the new leaves — what&apos;s wrong?
            </span>
          </div>
          <div className="self-start max-w-[86%] bg-white border border-[#E1E8DC] text-[.76rem] px-3 py-2.5 rounded-[14px] rounded-bl-[4px] leading-relaxed text-[#24361B]">
            Based on your
            {' '}
            <b>Chinese Hibiscus</b>
            {' '}
            and the photo, this looks like
            {' '}
            <b>fungal leaf spot</b>
            {' '}
            — common after Đà Lạt&apos;s rainy weeks. Remove the marked leaves, water at the base
            only, and improve airflow.
          </div>
          <div className="self-start max-w-[86%] bg-white border border-[#E1E8DC] text-[.76rem] px-3 py-2.5 rounded-[14px] leading-relaxed text-[#24361B]">
            Want a treatment plan with a reminder schedule?
          </div>
          <div className="flex gap-1.5 flex-wrap mt-0.5">
            <span className="text-[.7rem] font-semibold text-[#3E6B2A] border-[1.5px] border-[#98CC6B] px-2.5 py-1 rounded-full">Yes, make a plan</span>
            <span className="text-[.7rem] font-semibold text-[#3E6B2A] border-[1.5px] border-[#98CC6B] px-2.5 py-1 rounded-full">Is it toxic to pets?</span>
          </div>
        </div>
        <div className="flex-none px-3.5 pt-2.5 pb-5 bg-[#F2F5EF] flex gap-2 items-center">
          <span className="flex-1 bg-white border border-[#E1E8DC] rounded-full px-4 py-2.5 text-[.76rem] text-[#93A28B]">Ask about your plant…</span>
          <span className="w-[38px] h-[38px] rounded-full bg-[#98CC6B] text-[#24361B] grid place-items-center font-extrabold flex-none">↑</span>
        </div>
      </div>
    </>
  );
}

// Scroll-driven demo: step blocks on the left drive the sticky phone's screen on the right
export default function FloraiScrollDemo() {
  const [active, setActive] = useState(0);
  const stepsRef = useRef(null);

  useEffect(() => {
    // Sticky phone only exists at lg+; mobile shows a static phone per step
    const desktop = window.matchMedia('(min-width: 1024px)');
    const blocks = stepsRef.current
      ? Array.from(stepsRef.current.querySelectorAll('[data-step]'))
      : [];
    let ticking = false;
    const measure = () => {
      ticking = false;
      if (!desktop.matches || !blocks.length) return;
      const mid = window.innerHeight / 2;
      let best = 0;
      let bestDist = Infinity;
      blocks.forEach((el, i) => {
        const r = el.getBoundingClientRect();
        const d = Math.abs((r.top + r.bottom) / 2 - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      setActive(best);
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(measure);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <section id="florai-demo" className="florai px-4 !mb-4">
      <div className="relative bg-[#EEF2EC] text-[#24361B] rounded-[32px] [overflow:hidden] lg:[overflow:clip] max-w-[1400px] mx-auto">
        <FloraiSectionBackdrop overlayClass="bg-[#EEF2EC]/[.85]" positionClass="object-top" />
        <div className="relative z-10 max-w-[1120px] mx-auto pt-20 px-8">
          <p className="text-[.74rem] font-bold tracking-[.16em] uppercase text-[#5B8F3C] mb-3">Live demo</p>
          <h2 className="text-[clamp(1.9rem,3.8vw,2.8rem)] leading-tight mb-3.5 tracking-tight !font-semibold">
            Scroll through a
            {' '}
            <em className="font-instrument-serif !font-normal text-[1.08em]">real scan</em>
          </h2>
          <p className="text-[#5C6B53] max-w-2xl text-[1.05rem]">
            These are the actual app screens. Keep scrolling — the phone follows the story from
            photo to verdict.
          </p>
        </div>

        <div className="relative z-10 max-w-[1120px] mx-auto px-8 grid grid-cols-1 lg:grid-cols-[1fr_440px] gap-14">
          <div ref={stepsRef}>
            {steps.map((step, i) => (
              <div
                key={step.badge}
                data-step={i}
                className={`py-10 lg:py-0 lg:min-h-[78vh] flex flex-col justify-center transition-opacity duration-300 ${active === i ? 'opacity-100' : 'lg:opacity-40'}`}
              >
                <span className={`inline-flex w-fit text-[.72rem] font-bold tracking-[.08em] px-3.5 py-1 rounded-full mb-4 ${step.badgeClass}`}>
                  {step.badge}
                </span>
                <h3 className="mb-2.5 text-[1.8rem] !font-semibold tracking-tight">{step.title}</h3>
                <p className="text-[#5C6B53] max-w-md text-[1.02rem]">{step.body}</p>
                {/* Mobile: each step carries its own static phone so every screen is reachable */}
                <div className="lg:hidden mt-6 mx-auto w-[230px] aspect-[300/624] rounded-[36px] bg-[#0D1A11] border-8 border-[#1C2618] shadow-[0_24px_48px_rgba(36,54,27,.25)] relative overflow-hidden">
                  <PhoneScreens active={i} />
                </div>
              </div>
            ))}
          </div>

          <div className="relative hidden lg:block">
            <div className="sticky top-0 h-screen flex flex-col items-center justify-center gap-4">
              <div className="h-[min(624px,calc(100vh-64px))] aspect-[300/624] rounded-[44px] bg-[#0D1A11] border-[10px] border-[#1C2618] shadow-[0_40px_80px_rgba(36,54,27,.28)] relative overflow-hidden flex-none">
                <PhoneScreens active={active} />
              </div>
              <div className="flex gap-2" aria-hidden="true">
                {steps.map((step, i) => (
                  <span
                    key={step.badge}
                    className="h-2 rounded-full transition-all duration-300"
                    style={{
                      width: active === i ? 26 : 8,
                      background: active === i ? '#98CC6B' : '#CBDABF',
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
